import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";
export interface FileItemType {
  name: string;
  url: string;
}

const triggerDownload = (href: string, name: string) => {
  const link = document.createElement("a");
  link.href = href;
  link.download = name;
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadFile = async ({ name, url }: FileItemType) => {
  const handleDownloadFileItem = async () => {
    const response = await fetch(url, {
      credentials: "include",
    });
    if (!response.ok) throw new Error("download failed");

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);

    triggerDownload(objectUrl, name);

    window.setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 1000);
  };

  try {
    Toast({
      type: TOAST_TYPES_ENUM.LOADING,
      message: "ładowanie",
      id: "downloadFile",
    });
    await handleDownloadFileItem();
    Toast({
      type: TOAST_TYPES_ENUM.SUCCESS,
      message: "Pobrano plik",
      id: "downloadFile",
    });
  } catch (error) {
    Toast({
      type: TOAST_TYPES_ENUM.ERROR,
      message: "Błąd podczas pobierania pliku",
      id: "downloadFile",
    });
  }
};

export default downloadFile;
